<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}" (click)="scrollToTop()">
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
            <path
                d="M9.17741 32.2142C2.82292 26.8821 2.17387 20.3624 10.2936 12.5286C18.4133 4.69484 26.3102 4.81724 33.0296 10.4555C39.749 16.0938 35.8395 23.8061 30.4471 30.2326C25.0547 36.659 15.5319 37.5462 9.17741 32.2142Z"
                class="svg-background" />
            <g clip-path="url(#clip1)">
                <path
                    d="M19.8897 16.1085L14.1961 22.1818C13.9215 22.4747 13.9215 22.9495 14.1961 23.2424L14.8602 23.9508C15.1343 24.2432 15.5786 24.2437 15.8534 23.952L20.3869 19.1388L24.9205 23.952C25.1953 24.2437 25.6395 24.2432 25.9137 23.9508L26.5777 23.2424C26.8523 22.9495 26.8523 22.4746 26.5777 22.1818L20.8841 16.1085C20.6095 15.8156 20.1643 15.8156 19.8897 16.1085Z"
                    class="svg-sign" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0">
                <path d="M0 0H41.2524V41.8687H0V0Z" fill="white" />
            </clipPath>
            <clipPath id="clip1">
                <rect width="10" height="15" transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 27.6265 24.4343)"
                    fill="white" />
            </clipPath>
        </defs>
    </svg>
</div>